/**
 * Scroll to the WOM reviews section (PDP rating pill, social proof, etc.)
 */
(function () {
  if (typeof window === 'undefined') return;

  function findReviewsTarget() {
    var selectors = [
      '.shopify-section.wom-reviews-section',
      '.wom-reviews-section-box',
      '.wom-reviews-section',
      '[data-wom-widget="reviews"]',
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }

    var headings = document.querySelectorAll('h2, h3');
    for (var j = 0; j < headings.length; j++) {
      var heading = headings[j];
      if (heading.textContent && heading.textContent.toLowerCase().indexOf('review') !== -1) {
        var parent =
          heading.closest('.shopify-section.wom-reviews-section') ||
          heading.closest('.wom-reviews-section-box') ||
          heading.closest('[data-wom-widget="reviews"]') ||
          heading.closest('section');
        if (parent) return parent;
      }
    }

    return null;
  }

  function scrollToReviews(source) {
    try {
      var target = findReviewsTarget();
      if (!target) {
        setTimeout(function () {
          var retryTarget = findReviewsTarget();
          if (!retryTarget) return;
          var yRetry = retryTarget.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({ top: Math.max(0, yRetry), behavior: 'smooth' });
          window.dispatchEvent(
            new CustomEvent('wom-scroll-to-reviews', { detail: { source: source || 'unknown' } })
          );
        }, 500);
        return;
      }

      var y = target.getBoundingClientRect().top + window.pageYOffset - 100;
      try {
        target.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        setTimeout(function () {
          window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        }, 100);
      } catch (e) {
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      }

      window.dispatchEvent(
        new CustomEvent('wom-scroll-to-reviews', { detail: { source: source || 'unknown' } })
      );
    } catch (err) {
}
  }

  window.womScrollToReviews = scrollToReviews;
})();
